<template>
    <vx-card title="Dodatki" class="mt-6">
        <vs-table noDataText="Ni dodatkov" ref="table" v-model="selected" @selected="handleSelected" pagination :max-items="50" search :data="additions">

            <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                <div class="flex flex-wrap-reverse items-center">
                    <vs-button class="mb-3" color="success" icon-pack="feather" icon="icon-plus-circle" @click="addAdditionPrompt = true">Dodaj</vs-button>
                </div>

                <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
                    <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                        <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ additions.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : additions.length }} of {{ additions.length }}</span>
                        <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                    </div>

                    <vs-dropdown-menu>

                        <vs-dropdown-item @click="itemsPerPage=10">
                            <span>10</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=20">
                            <span>20</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=50">
                            <span>50</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=100">
                            <span>100</span>
                        </vs-dropdown-item>
                    </vs-dropdown-menu>
                </vs-dropdown>
            </div>

            <template slot="thead">
                <vs-th sort-key="name">Ime</vs-th>
                <vs-th sort-key="price">Cena</vs-th>
            </template>

            <template slot-scope="{data}">
                <tbody>
                <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

                    <vs-td :data="data[index].name">
                        {{ data[index].name }}
                    </vs-td>

                    <vs-td :data="data[index].price">
                        {{ data[index].price }}
                    </vs-td>

                </vs-tr>
                </tbody>
            </template>

        </vs-table>

        <vs-popup title="Dodaj dodatek" :active.sync="addAdditionPrompt">
            <div>
                <p class="mt-6">Ime</p>
                <vs-input v-model="addName" style="width: 100%"></vs-input>
                <p class="mt-6">Cena</p>
                <vs-input v-model="addPrice" style="width: 100%"></vs-input>
                <vs-divider/>
                <vs-button color="success" type="border" class="mt-6; mr-1" @click="addAddition">Dodaj</vs-button>
            </div>
        </vs-popup>

        <vs-popup title="Uredi" :active.sync="editAdditionPrompt">
            <div>
                <p class="mt-6">Ime</p>
                <vs-input v-model="editName" style="width: 100%"></vs-input>
                <p class="mt-6">Cena</p>
                <vs-input v-model="editPrice" style="width: 100%"></vs-input>
                <vs-divider/>
                <vs-button style="float: left" color="success" icon-pack="feather" icon="icon-edit" class="mt-6; mr-1" @click="editAddition">Shrani</vs-button>
                <vs-button style="float: right" color="danger" icon-pack="feather" icon="icon-trash-2" @click="removeAddition">Izbriši</vs-button>
            </div>
        </vs-popup>

    </vx-card>
</template>
<script>

    export default {
        props: {
            baseURL: {
                type: String,
                required: true
            },
        },
        data(){
            return {

                selected: {},
                additions: [],

                itemsPerPage: 20,
                isMounted: false,

                addAdditionPrompt: false,
                editAdditionPrompt: false,

                addName: '',
                addPrice: 0.0,

                editName: '',
                editPrice: 0.0
            }
        },
        computed: {
            currentPage() {
                if(this.isMounted) {
                    return this.$refs.table.currentx
                }
                return 0
            },
        },
        methods: {
            handleSelected(tr) {
                this.editName = tr.name;
                this.editPrice = tr.price;
                this.editAdditionPrompt = true;
            },
            updateAdditions() {
                const thisIns = this;
                this.$http.get(this.baseURL + "/addition")
                    .then(function (response) {
                        thisIns.additions = response.data;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title: 'Error',
                            text: error,
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        })
                    });
            },
            addAddition(){
                const thisIns = this;
                this.addPrice = this.addPrice.replace(",", ".");
                this.$http.post(this.baseURL + "/addition", {
                    name: this.addName,
                    price: Number(this.addPrice)
                })
                    .then(function () {
                        thisIns.updateAdditions();
                        thisIns.addAdditionPrompt = false;
                        thisIns.addName = ''
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title: 'Error',
                            text: error,
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        })
                    });
            },
            editAddition(){
                const thisIns = this;
                this.editPrice = this.editPrice.replace(",", ".");
                this.$http.put(this.baseURL + "/addition/" + this.selected.id, {
                    name: this.editName,
                    price: Number(this.editPrice)
                })
                    .then(function () {
                        thisIns.updateAdditions();
                        thisIns.editAdditionPrompt = false;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title: 'Error',
                            text: error,
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        })
                    });
            },
            removeAddition(){
                const thisIns = this;
                this.$http.delete(this.baseURL + "/addition/" + this.selected.id)
                    .then(function () {
                        thisIns.updateAdditions();
                        thisIns.editAdditionPrompt = false;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title: 'Error',
                            text: error,
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        })
                    });
            }
        },
        watch: {
            editAdditionPrompt: function () {
                if(!this.editAdditionPrompt){
                    this.selected = {}
                }
            },
            baseURL(){
                this.updateAdditions();
            }
        },
        created() {
            this.updateAdditions()
        },
        mounted() {
            this.isMounted = true;
        },
    }

</script>
